import {Entity} from '@s-ui/domain'

export class PackEntity extends Entity {
  /**
   * @constructor
   * @param {Object} data
   * @param {String} data.legacyId
   * @param {String} data.type
   */
}
